(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')		{ module.exports = factory(); }	else if(typeof define === 'function' && define.amd)		{ define("ScrollBlock", [], factory); }	else if(typeof exports === 'object')		{ exports["ScrollBlock"] = factory(); }	else		{ root["ScrollBlock"] = factory(); }
})(globalThis, function() {
	return /******/ (function(modules) { // webpackBootstrap
		/******/ 	// The module cache
		/******/ 	var installedModules = {};
		/******/
		/******/ 	// The require function
		/******/ 	function __webpack_require__(moduleId) {
			/******/
			/******/ 		// Check if module is in cache
			/******/ 		if(installedModules[moduleId]) {
			/******/			return installedModules[moduleId].exports;
			/******/		}
			/******/
			/******/ 		// Create a new module (and put it into the cache)
			/******/ 		var module = installedModules[moduleId] = {
				/******/ 			exports: {},
				/******/ 			id: moduleId,
				/******/ 			loaded: false
				/******/ 		};
			/******/
			/******/ 		// Execute the module function
			/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
			/******/
			/******/ 		// Flag the module as loaded
			/******/ 		module.loaded = true;
			/******/
			/******/ 		// Return the exports of the module
			/******/ 		return module.exports;
			/******/ 	}
		/******/
		/******/
		/******/ 	// expose the modules object (__webpack_modules__)
		/******/ 	__webpack_require__.m = modules;
		/******/
		/******/ 	// expose the module cache
		/******/ 	__webpack_require__.c = installedModules;
		/******/
		/******/ 	// __webpack_public_path__
		/******/ 	__webpack_require__.p = "";
		/******/
		/******/ 	// Load entry module and return exports
		/******/ 	return __webpack_require__(0);
		/******/ })
	/************************************************************************/
	/******/ ([
		/* 0 */
		/***/ function(module, exports, __webpack_require__) {

			Object.defineProperty(exports, "__esModule", {
				value: true
			});

			var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) { descriptor.writable = true; } Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) { defineProperties(Constructor.prototype, protoProps); } if (staticProps) { defineProperties(Constructor, staticProps); } return Constructor; }; }();

			var _utilities = __webpack_require__(1);

			var Utils = _interopRequireWildcard(_utilities);

			var _viewportLock = __webpack_require__(33);

			var ViewPort = _interopRequireWildcard(_viewportLock);

			function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { newObj[key] = obj[key]; } } } newObj.default = obj; return newObj; } }

			function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

			var _globallyBlocked = false;
			var _globallyIgnored = [];

			function isInIgnoredElement(targetEl) {
				return _globallyIgnored.some(function (el) {
					return el.contains(targetEl);
				});
			}

			function preventDefault(e) {
				if (!isInIgnoredElement(e.target)) {
					e.preventDefault();
				}
			}

			var currentTarget = null;
			var cachedVerticalPosition = 0;
			var cachedHorizontalPosition = 0;

			function mouseDown(e) {
				if (isInIgnoredElement(e.target)) {
					return false;
				}
				currentTarget = e.target;
				cachedVerticalPosition = currentTarget.scrollTop;
				cachedHorizontalPosition = currentTarget.scrollLeft;

				currentTarget.addEventListener('mouseup', mouseUp);
				currentTarget.addEventListener('scroll', scrollBarDrag);
			}

			function mouseUp() {
				scrollBarDrag();
				currentTarget.removeEventListener('mouseup', mouseUp);
				currentTarget.removeEventListener('scroll', scrollBarDrag);
			}

			function scrollBarDrag() {
				currentTarget.scrollTop = cachedVerticalPosition;
				currentTarget.scrollLeft = cachedHorizontalPosition;
			}

			function turnBlockingOn() {
				ViewPort.lock();

				Utils.addEvent(window, 'wheel', preventDefault);
				Utils.addEvent(window, 'mousedown', mouseDown);
				_globallyBlocked = true;
			}

			function turnBlockingOff() {
				ViewPort.unlock();

				Utils.removeEvent(window, 'wheel', preventDefault);
				Utils.removeEvent(window, 'mousedown', mouseDown);
				_globallyBlocked = false;
			}

			var ScrollBlock = function () {
				function ScrollBlock() {
					// this.blocked = false;
					// this.ignoredElements = [];

					_classCallCheck(this, ScrollBlock);
				}

				_createClass(ScrollBlock, null, [{
					key: 'on',
					value: function on() {
						if (!_globallyBlocked) {
							turnBlockingOn();
						}
					}
				}, {
					key: 'off',
					value: function off() {
						if (_globallyBlocked) {
							turnBlockingOff();
						}
					}
				}, {
					key: 'toggle',
					value: function toggle() {
						var shouldTurnOn = arguments.length <= 0 || arguments[0] === undefined ? !_globallyBlocked : arguments[0];

						if (shouldTurnOn) {
							this.on();
						} else {
							this.off();
						}
					}
				}, {
					key: 'ignore',
					value: function ignore(selectorOrElement) {
						if (selectorOrElement && selectorOrElement.tagName) {
							_globallyIgnored.push(selectorOrElement);
						} else {
							_globallyIgnored = _globallyIgnored.concat(Array.from(document.querySelectorAll(selectorOrElement)).filter(function (el) {
								return !_globallyIgnored.includes(el);
							}));
						}
					}
				}, {
					key: 'removeIgnored',
					value: function removeIgnored(selectorOrElement) {
						if (selectorOrElement && selectorOrElement.tagName) {
							_globallyIgnored = _globallyIgnored.filter(function (el) {
								return el !== selectorOrElement;
							});
						} else {
							(function () {
								var elements = Array.from(document.querySelectorAll(selectorOrElement));
								_globallyIgnored = _globallyIgnored.filter(function (el) {
									return !elements.includes(el);
								});
							})();
						}
					}
				}, {
					key: 'isBlocked',
					get: function get() {
						return _globallyBlocked;
					}
				}, {
					key: 'ignoredElements',
					get: function get() {
						return _globallyIgnored;
					}
				}]);

				return ScrollBlock;
			}();

			exports.default = ScrollBlock;
			module.exports = exports['default'];

			/***/ },
		/* 1 */
		/***/ function(module, exports, __webpack_require__) {

			Object.defineProperty(exports, "__esModule", {
				value: true
			});
			exports.addEvent = addEvent;
			exports.removeEvent = removeEvent;
			exports.addClass = addClass;
			exports.removeClass = removeClass;

			__webpack_require__(2);

			function addEvent(element, eventName, callback) {
				element.addEventListener(eventName, callback);
			}

			function removeEvent(element, eventName, callback) {
				element.removeEventListener(eventName, callback);
			}

			function addClass(element) {
				var currentClasses = element.className.trim().split(/\s+/);

				for (var _len = arguments.length, classes = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
					classes[_key - 1] = arguments[_key];
				}

				element.className = currentClasses.concat(classes.filter(function (cls) {
					return !currentClasses.includes(cls.trim());
				})).join(' ').trim();
			}

			function removeClass(element) {
				for (var _len2 = arguments.length, classes = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
					classes[_key2 - 1] = arguments[_key2];
				}

				element.className = element.className.trim().split(/\s+/).filter(function (cls) {
					return !classes.includes(cls.trim());
				}).join(' ').trim();
			}

			/***/ },
		/* 2 */
		/***/ function(module, exports, __webpack_require__) {

			__webpack_require__(3);
			module.exports = __webpack_require__(6).Array.includes;

			/***/ },
		/* 3 */
		/***/ function(module, exports, __webpack_require__) {
			// https://github.com/tc39/Array.prototype.includes
			var $export   = __webpack_require__(4)
				, $includes = __webpack_require__(22)(true);

			$export($export.P, 'Array', {
				includes: function includes(el /*, fromIndex = 0 */){
					return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
				}
			});

			__webpack_require__(30)('includes');

			/***/ },
		/* 4 */
		/***/ function(module, exports, __webpack_require__) {

			var global    = __webpack_require__(5)
				, core      = __webpack_require__(6)
				, hide      = __webpack_require__(7)
				, redefine  = __webpack_require__(17)
				, ctx       = __webpack_require__(20)
				, PROTOTYPE = 'prototype';

			var $export = function(type, name, source){
				var IS_FORCED = type & $export.F
					, IS_GLOBAL = type & $export.G
					, IS_STATIC = type & $export.S
					, IS_PROTO  = type & $export.P
					, IS_BIND   = type & $export.B
					, target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
					, exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
					, expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
					, key, own, out, exp;
				if(IS_GLOBAL){ source = name; }
				for(key in source){
					// contains in native
					own = !IS_FORCED && target && target[key] !== undefined;
					// export native or passed
					out = (own ? target : source)[key];
					// bind timers to global for call from export context
					exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
					// extend global
					if(target){ redefine(target, key, out, type & $export.U); }
					// export
					if(exports[key] != out){ hide(exports, key, exp); }
					if(IS_PROTO && expProto[key] != out){ expProto[key] = out; }
				}
			};
			global.core = core;
			// type bitmap
			$export.F = 1;   // forced
			$export.G = 2;   // global
			$export.S = 4;   // static
			$export.P = 8;   // proto
			$export.B = 16;  // bind
			$export.W = 32;  // wrap
			$export.U = 64;  // safe
			$export.R = 128; // real proto method for `library`
			module.exports = $export;

			/***/ },
		/* 5 */
		/***/ function(module, exports) {

			// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
			var global = module.exports = typeof window != 'undefined' && window.Math == Math
				? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
			if(typeof __g == 'number'){ __g = global; } // eslint-disable-line no-undef

			/***/ },
		/* 6 */
		/***/ function(module, exports) {

			var core = module.exports = {version: '2.4.0'};
			if(typeof __e == 'number'){ __e = core; } // eslint-disable-line no-undef

			/***/ },
		/* 7 */
		/***/ function(module, exports, __webpack_require__) {

			var dP         = __webpack_require__(8)
				, createDesc = __webpack_require__(16);
			module.exports = __webpack_require__(12) ? function(object, key, value){
				return dP.f(object, key, createDesc(1, value));
			} : function(object, key, value){
				object[key] = value;
				return object;
			};

			/***/ },
		/* 8 */
		/***/ function(module, exports, __webpack_require__) {

			var anObject       = __webpack_require__(9)
				, IE8_DOM_DEFINE = __webpack_require__(11)
				, toPrimitive    = __webpack_require__(15)
				, dP             = Object.defineProperty;

			exports.f = __webpack_require__(12) ? Object.defineProperty : function defineProperty(O, P, Attributes){
				anObject(O);
				P = toPrimitive(P, true);
				anObject(Attributes);
				if(IE8_DOM_DEFINE){
try {
					return dP(O, P, Attributes);
				} catch(e){ /* empty */ }
}
				if('get' in Attributes || 'set' in Attributes){ throw TypeError('Accessors not supported!'); }
				if('value' in Attributes){ O[P] = Attributes.value; }
				return O;
			};

			/***/ },
		/* 9 */
		/***/ function(module, exports, __webpack_require__) {

			var isObject = __webpack_require__(10);
			module.exports = function(it){
				if(!isObject(it)){ throw TypeError(it + ' is not an object!'); }
				return it;
			};

			/***/ },
		/* 10 */
		/***/ function(module, exports) {

			module.exports = function(it){
				return typeof it === 'object' ? it !== null : typeof it === 'function';
			};

			/***/ },
		/* 11 */
		/***/ function(module, exports, __webpack_require__) {

			module.exports = !__webpack_require__(12) && !__webpack_require__(13)(function(){
					return Object.defineProperty(__webpack_require__(14)('div'), 'a', {get: function(){ return 7; }}).a != 7;
				});

			/***/ },
		/* 12 */
		/***/ function(module, exports, __webpack_require__) {

			// Thank's IE8 for his funny defineProperty
			module.exports = !__webpack_require__(13)(function(){
				return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
			});

			/***/ },
		/* 13 */
		/***/ function(module, exports) {

			module.exports = function(exec){
				try {
					return !!exec();
				} catch(e){
					return true;
				}
			};

			/***/ },
		/* 14 */
		/***/ function(module, exports, __webpack_require__) {

			var isObject = __webpack_require__(10)
				, document = __webpack_require__(5).document
				// in old IE typeof document.createElement is 'object'
				, is = isObject(document) && isObject(document.createElement);
			module.exports = function(it){
				return is ? document.createElement(it) : {};
			};

			/***/ },
		/* 15 */
		/***/ function(module, exports, __webpack_require__) {

			// 7.1.1 ToPrimitive(input [, PreferredType])
			var isObject = __webpack_require__(10);
			// instead of the ES6 spec version, we didn't implement @@toPrimitive case
			// and the second argument - flag - preferred type is a string
			module.exports = function(it, S){
				if(!isObject(it)){ return it; }
				var fn, val;
				if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))){ return val; }
				if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))){ return val; }
				if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))){ return val; }
				throw TypeError("Can't convert object to primitive value");
			};

			/***/ },
		/* 16 */
		/***/ function(module, exports) {

			module.exports = function(bitmap, value){
				return {
					enumerable  : !(bitmap & 1),
					configurable: !(bitmap & 2),
					writable    : !(bitmap & 4),
					value       : value
				};
			};

			/***/ },
		/* 17 */
		/***/ function(module, exports, __webpack_require__) {

			var global    = __webpack_require__(5)
				, hide      = __webpack_require__(7)
				, has       = __webpack_require__(18)
				, SRC       = __webpack_require__(19)('src')
				, TO_STRING = 'toString'
				, $toString = Function[TO_STRING]
				, TPL       = ('' + $toString).split(TO_STRING);

			__webpack_require__(6).inspectSource = function(it){
				return $toString.call(it);
			};

			(module.exports = function(O, key, val, safe){
				var isFunction = typeof val == 'function';
				if(isFunction){ has(val, 'name') || hide(val, 'name', key); }
				if(O[key] === val){ return; }
				if(isFunction){ has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key))); }
				if(O === global){
					O[key] = val;
				} else {
					if(!safe){
						delete O[key];
						hide(O, key, val);
					} else {
						if(O[key]){ O[key] = val; }						else { hide(O, key, val); }
					}
				}
				// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
			})(Function.prototype, TO_STRING, function toString(){
				return typeof this == 'function' && this[SRC] || $toString.call(this);
			});

			/***/ },
		/* 18 */
		/***/ function(module, exports) {

			var hasOwnProperty = {}.hasOwnProperty;
			module.exports = function(it, key){
				return hasOwnProperty.call(it, key);
			};

			/***/ },
		/* 19 */
		/***/ function(module, exports) {

			var id = 0
				, px = Math.random();
			module.exports = function(key){
				return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
			};

			/***/ },
		/* 20 */
		/***/ function(module, exports, __webpack_require__) {

			// optional / simple context binding
			var aFunction = __webpack_require__(21);
			module.exports = function(fn, that, length){
				aFunction(fn);
				if(that === undefined){ return fn; }
				switch(length){
					case 1: return function(a){
						return fn.call(that, a);
					};
					case 2: return function(a, b){
						return fn.call(that, a, b);
					};
					case 3: return function(a, b, c){
						return fn.call(that, a, b, c);
					};
				}
				return function(/* ...args */){
					return fn.apply(that, arguments);
				};
			};

			/***/ },
		/* 21 */
		/***/ function(module, exports) {

			module.exports = function(it){
				if(typeof it != 'function'){ throw TypeError(it + ' is not a function!'); }
				return it;
			};

			/***/ },
		/* 22 */
		/***/ function(module, exports, __webpack_require__) {

			// false -> Array#indexOf
			// true  -> Array#includes
			var toIObject = __webpack_require__(23)
				, toLength  = __webpack_require__(27)
				, toIndex   = __webpack_require__(29);
			module.exports = function(IS_INCLUDES){
				return function($this, el, fromIndex){
					var O      = toIObject($this)
						, length = toLength(O.length)
						, index  = toIndex(fromIndex, length)
						, value;
					// Array#includes uses SameValueZero equality algorithm
					if(IS_INCLUDES && el != el){
while(length > index){
						value = O[index++];
						if(value != value){ return true; }
						// Array#toIndex ignores holes, Array#includes - not
					}
} else {
for(;length > index; index++){
if(IS_INCLUDES || index in O){
						if(O[index] === el){ return IS_INCLUDES || index || 0; }
					}
}
} return !IS_INCLUDES && -1;
				};
			};

			/***/ },
		/* 23 */
		/***/ function(module, exports, __webpack_require__) {

			// to indexed object, toObject with fallback for non-array-like ES3 strings
			var IObject = __webpack_require__(24)
				, defined = __webpack_require__(26);
			module.exports = function(it){
				return IObject(defined(it));
			};

			/***/ },
		/* 24 */
		/***/ function(module, exports, __webpack_require__) {

			// fallback for non-array-like ES3 and non-enumerable old V8 strings
			var cof = __webpack_require__(25);
			module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
				return cof(it) == 'String' ? it.split('') : Object(it);
			};

			/***/ },
		/* 25 */
		/***/ function(module, exports) {

			var toString = {}.toString;

			module.exports = function(it){
				return toString.call(it).slice(8, -1);
			};

			/***/ },
		/* 26 */
		/***/ function(module, exports) {

			// 7.2.1 RequireObjectCoercible(argument)
			module.exports = function(it){
				if(it == undefined){ throw TypeError("Can't call method on  " + it); }
				return it;
			};

			/***/ },
		/* 27 */
		/***/ function(module, exports, __webpack_require__) {

			// 7.1.15 ToLength
			var toInteger = __webpack_require__(28)
				, min       = Math.min;
			module.exports = function(it){
				return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
			};

			/***/ },
		/* 28 */
		/***/ function(module, exports) {

			// 7.1.4 ToInteger
			var ceil  = Math.ceil
				, floor = Math.floor;
			module.exports = function(it){
				return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
			};

			/***/ },
		/* 29 */
		/***/ function(module, exports, __webpack_require__) {

			var toInteger = __webpack_require__(28)
				, max       = Math.max
				, min       = Math.min;
			module.exports = function(index, length){
				index = toInteger(index);
				return index < 0 ? max(index + length, 0) : min(index, length);
			};

			/***/ },
		/* 30 */
		/***/ function(module, exports, __webpack_require__) {

			// 22.1.3.31 Array.prototype[@@unscopables]
			var UNSCOPABLES = __webpack_require__(31)('unscopables')
				, ArrayProto  = Array.prototype;
			if(ArrayProto[UNSCOPABLES] == undefined){ __webpack_require__(7)(ArrayProto, UNSCOPABLES, {}); }
			module.exports = function(key){
				ArrayProto[UNSCOPABLES][key] = true;
			};

			/***/ },
		/* 31 */
		/***/ function(module, exports, __webpack_require__) {

			var store      = __webpack_require__(32)('wks')
				, uid        = __webpack_require__(19)
				, Symbol     = __webpack_require__(5).Symbol
				, USE_SYMBOL = typeof Symbol == 'function';

			var $exports = module.exports = function(name){
				return store[name] || (store[name] =
						USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
			};

			$exports.store = store;

			/***/ },
		/* 32 */
		/***/ function(module, exports, __webpack_require__) {

			var global = __webpack_require__(5)
				, SHARED = '__core-js_shared__'
				, store  = global[SHARED] || (global[SHARED] = {});
			module.exports = function(key){
				return store[key] || (store[key] = {});
			};

			/***/ },
		/* 33 */
		/***/ function(module, exports, __webpack_require__) {

			Object.defineProperty(exports, "__esModule", {
				value: true
			});

			var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

			exports.lock = lock;
			exports.unlock = unlock;

			var _scrollbarDetector = __webpack_require__(34);

			var Bars = _interopRequireWildcard(_scrollbarDetector);

			function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { newObj[key] = obj[key]; } } } newObj.default = obj; return newObj; } }

			var html = document.querySelector('html');

			var styleNamesWeUse = ['overflow', 'position', 'width', 'top', 'left'];

			var htmlLockStyles = {
				overflowY: 'auto',
				overflowX: 'auto',
				position: 'fixed',
				width: '100%',
				top: undefined,
				left: undefined
			};

			var windowScrollPosition = {
				top: null,
				left: null
			};

			var savedHtmlInlineStyles = {};

			function saveScrollPosition() {
				windowScrollPosition.top = window.pageYOffset;
				windowScrollPosition.left = window.pageXOffset;
			}

			function saveHtmlTagStyles() {
				var styles = {};
				styleNamesWeUse.forEach(function (styleName) {
					var value = html.style[styleName];
					if (value) {
						styles[styleName] = value;
					}
				});
				savedHtmlInlineStyles = styles;
			}

			function scrollBackToSavedPosition() {
				window.scrollTo(windowScrollPosition.left, windowScrollPosition.top);
			}

			function lock() {
				saveScrollPosition();
				saveHtmlTagStyles();

				var htmlScrollBars = Bars.elementHasScrollBars(html);

				var lockStyles = _extends({}, htmlLockStyles, {
					top: -windowScrollPosition.top + 'px',
					left: -windowScrollPosition.left + 'px',
					overflowY: htmlScrollBars.vertical ? 'scroll' : 'auto',
					overflowX: htmlScrollBars.horizontal ? 'scroll' : 'auto'
				});

				Object.keys(lockStyles).forEach(function (styleName) {
					html.style[styleName] = lockStyles[styleName];
				});
			}

			function unlock() {
				styleNamesWeUse.forEach(function (styleName) {
					html.style[styleName] = savedHtmlInlineStyles[styleName] || '';
				});

				scrollBackToSavedPosition();
			}

			/***/ },
		/* 34 */
		/***/ function(module, exports) {

			Object.defineProperty(exports, "__esModule", {
				value: true
			});
			exports.default = getScrollBarData;
			exports.elementHasScrollBars = elementHasScrollBars;
			function getScrollBarData() {
				var active = false;
				var size = 0;

				var outerDiv = document.createElement('div');
				outerDiv.style.height = '200px';
				outerDiv.style.width = '200px';
				outerDiv.style.position = 'fixed';
				outerDiv.style.top = '-100%';
				outerDiv.style.left = '-100%';
				outerDiv.style.overflow = 'scroll';

				// outerDiv.style.top = '0px';
				// outerDiv.style.left = '0px';
				// outerDiv.backgroundColor = 'lightyellow';

				var appendElement = document.body || document.querySelector('html');

				appendElement.appendChild(outerDiv);

				if (outerDiv.clientWidth < outerDiv.offsetWidth) {
					active = true;
					size = outerDiv.offsetWidth - outerDiv.clientWidth;
				}

				appendElement.removeChild(outerDiv);

				return {
					active: active,
					size: size
				};
			}

			function elementHasScrollBars(element) {
				var overflowY = window.getComputedStyle(element)['overflow-y'];
				var overflowX = window.getComputedStyle(element)['overflow-x'];
				return {
					horizontal: (overflowX === 'scroll' || overflowX === 'auto') && element.scrollWidth > element.clientWidth,
					vertical: (overflowY === 'scroll' || overflowY === 'auto') && element.scrollHeight > element.clientHeight
				};
			}

			/***/ }
		/******/ ])
});
